import { IReportPartner } from 'partner360/models/report/IReportPartner'

export const sortReportPartners = <T extends IReportPartner>(data: T[]): T[] => {
  return data
    .sort((a, b) => {
      return a.GeoMarketOrder - b.GeoMarketOrder
    })
    .sort((a, b) => (a.GlobalPartnerName || '').localeCompare(b.GlobalPartnerName || ''))
}
